import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { NgForm } from "@angular/forms";

import { ActivatedRoute, Router } from "@angular/router";
import { SistemaService } from "@core/services/sistema.service";
import { repeaterAnimation } from 'app/main/pages/invoice/invoice.animation';
import { AuthenticationService } from "app/auth/service";
import { TabelaPrecoService } from "app/services/tabela-preco.service";
import { Subscription } from "rxjs";
import Swal from "sweetalert2";
import { NgbDateAdapter, NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { CustomAdapter, CustomDateParserFormatter } from "../../pedido/form-pedido/form-pedido.component";
import * as moment from 'moment';


@Component({
  selector: 'app-tabela-preco-form',
  templateUrl: './tabela-preco-form.component.html',
  styleUrls: ['./tabela-preco-form.component.scss'],
  animations: [repeaterAnimation],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class TabelaPrecoFormComponent implements OnInit {
  //colunas
  public id_component: number;
  public nome: string;
  public isLoading = false;
  dt_inicio;
  dt_fim;
  public items = [];
  valorTotal: number = 0;

  public href;

  public contentHeader: object;
  private routeSub: Subscription;

  constructor(
    private route: ActivatedRoute,
    private tabelaPrecoService: TabelaPrecoService,
    private _router: Router
  ) { }

  ngOnInit() {
    this.href = this.route.url;

    if (this.href.value[1].path == "cadastro") {
      this.contentHeader = {
        headerTitle: "Cadastrar Tabela de Preço",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Início",
              isLink: false,
            },
            {
              name: "Tabela de Preço",
              isLink: false,
            },
            {
              name: "Cadastrar",
              isLink: false,
            },
          ],
        },
      };
    }

    if (this.href.value[1].path == "visualizar") {
      this.routeSub = this.route.params.subscribe((params) => {
        this.tabelaPrecoService.getOne(params["id"]).subscribe(
          (res) => {
            if (res.statusCode == 200) {
              this.nome = res.data.tabela.nome;
              this.dt_inicio = moment(res.data.tabela.dt_inicio).add(3, 'hours').local().format('YYYY-MM-DD');
              this.dt_fim = moment(res.data.tabela.dt_fim).add(3, 'hours').local().format('YYYY-MM-DD');
              res.data.itens.forEach(element => {
                let newObj = {
                  qtd_inicio: element.qtd_inicio,
                  qtd_fim: element.qtd_fim,
                  item_valor: element.valor_ativo
                };
                this.items.push(newObj)
              });
            }
          },
          (error) => error
        );
      });

      this.contentHeader = {
        headerTitle: "Editar Tabela de Preço",
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Início",
              isLink: false,
            },
            {
              name: "Tabela de Preço",
              isLink: false,
            },
            {
              name: "Visualizar",
              isLink: false,
            },
          ],
        },
      };
    }
  }

  addItem() {
    let newObj = {
      qtd_inicio: null,
      qtd_fim: null,
      item_valor: null
    };
    this.items = [...this.items, newObj];
  }

  deleteItem(id) {
    for (let i = 0; i < this.items.length; i++) {
      if (this.items.indexOf(this.items[i]) === id) {
        this.items.splice(i, 1);
        break;
      }
    }
    this.alterarTotal()
  }


  selectItem(item, index) {
    this.items[index].itemTipo = item.target.value;
  }

  public submitForm() {
    if (this.href.value[1].path == "cadastro") {
      this.isLoading = true;
      this.tabelaPrecoService.post({ nome: this.nome, dt_inicio: this.dt_inicio, dt_fim: this.dt_fim, itens: this.items }).subscribe(
        (res) => {
          if (res.statusCode == 201) {
            this.isLoading = false;
            Swal.fire({
              title: "Sucesso!",
              text: "O item foi cadastrado.",
              icon: "success",
              confirmButtonText: "Confirmar",
            }).then((result) => {
              if (result.isConfirmed) {
                this._router.navigate(['tabela-preco'])
              }
            });
          }
        },
        (error) => {
          this.isLoading = false;
          Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
        }
      );
    }
  }

  alterarTotal() {
    this.valorTotal = 0
    this.items.forEach(item => {
      this.valorTotal = this.valorTotal + (item.itemValor * item.quantidade)
    });
  }

  // ngOnDestroy() {
  //   this.routeSub.unsubscribe();
  // }
}

function reformatDate(dateStr) {
  let dArr = dateStr.split("-");
  return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(2);
}
